import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

//console.log('environment', environment);

if (environment.production) {
    enableProdMode();

    // Disable console.log, console.warn, and console.error in production
    window.console.log = function () {
        // disable logs
    };
    window.console.warn = function () {
        // disable logs
    };
    // // uncomment below line if you want to disable the console.error also in browser
    // //window.console.error = function () {};
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
